import type { MenuDataItem } from '@ant-design/pro-components';
import { create } from 'zustand';
import { buildRouteManifest } from '@/router/transform';
import { getRouteTreeRequest } from '@/services/modules/route';
import { useAuthStore } from '@/stores/auth';
import type { AppRouteMap, AppRouteNode } from '@/types/route';

interface RouteState {
  routeTree: AppRouteNode[];
  routeMap: AppRouteMap;
  menuData: MenuDataItem[];
  firstLeafPath?: string;
  loaded: boolean;
  bootstrap: () => Promise<void>;
  reset: () => void;
}

const initialState = {
  routeTree: [],
  routeMap: {},
  menuData: [],
  firstLeafPath: undefined,
  loaded: false,
};

export const useRouteStore = create<RouteState>((set) => ({
  ...initialState,
  bootstrap: async () => {
    // 登录成功后只拉一次后台路由，再统一生成菜单和运行时页面映射。
    const routes = await getRouteTreeRequest();
    const authState = useAuthStore.getState();
    const manifest = buildRouteManifest(routes, {
      roles: authState.roles,
      permissions: authState.permissions,
    });

    set({
      ...manifest,
      loaded: true,
    });
  },
  reset: () => {
    // 退出登录时一起清空菜单和页面映射，避免串账号。
    set(initialState);
  },
}));
